import firebase from 'firebase'
import firebaseui from 'firebaseui'
import {FIREBASE_CONFIG} from '@/config'
import store from '@/store'

require('firebase/firestore')

const authApp = firebase.initializeApp(FIREBASE_CONFIG, 'auth')
const detachedAuth = authApp.auth()

export function createUserWithEmailAndPassword (email, password) {
  return detachedAuth.createUserWithEmailAndPassword(email, password)
}



// WEBPACK FOOTER //
// ./src/firebaseAuth.js